module.exports = __webpack_public_path__ + "static/media/richard.8e368ac5.jpg";